import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "editor-button" }

import FaIcon from '@/core/components/FaIcon.vue';

interface AppEditorButtonProps {
	icon?: string;
	text?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppEditorButton',
  props: {
    icon: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (__props.icon)
      ? (_openBlock(), _createBlock(FaIcon, {
          key: 0,
          icon: __props.icon
        }, null, 8, ["icon"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(__props.text), 1)
        ], 64))
  ]))
}
}

})